import React from 'react';
import './pageHeader.scss';
import searchIcon from './searchReg.svg';
import addIcon from './plus.svg';

const RegistrySearchHeader = (props) => {
  const {
    onClick,
    onChange,
    placeholder,
    searchValue,
    buttonText,
    button,
    showInput,
    showButton,
  } = props;

  return (
    <div className="registry-search-header">
      {showInput ? (
        <div className="registry-search-header__input">
          <>
            <input
              type="text"
              className="search-field"
              placeholder={placeholder}
              onChange={(e) => onChange(e)}
              value={searchValue}
            />
            <img src={searchIcon} alt="search" style={{width: "12px"}}/>
          </>
        </div>
      ) : (
        <div></div>
      )}
      {showButton &&
        (buttonText ? (
          <button
            className="registry-search-header__button--submit"
            onClick={onClick}
          >
            <img src={addIcon} alt="add" />
            {buttonText}
          </button>
        ) : (
          <div className="registry-modal-button">{button}</div>
        ))}
    </div>
  );
};

export default RegistrySearchHeader;

/*
* PERMISSION PROPS:
* - showInput === true/false --> displays the search field according to users permissions
* - showButton === true/false --> displays the add button according to users permissions
*
* USE CASE 1: PASSING AN EXTERNAL BUTTON COMPONENT
* REQUIRED PROPS : onChange, placeholder, button
* LEAVE buttonText prop undefined !!!
* - placeholder prop will be used as a search field placeholder
* - onChange props purpose should be to pass the search field input back to the parent component
* - button props purpose is to pass your own custom button component
* - searchValue prop is passed as controlled input value from the parent component
* EXAMPLE:
* <RegistrySearchHeader
        placeholder={t("registers.functionalSystemChanges.placeholder.search")}
        button={<Add id="functionalSystemChanges" setRowChanged={() => onRowChange()} />}
        onChange={(e) => onSearch(e)}
        showInput={viewResourcePermissionExists}
        showButton={createResourcePermissionExists}
        searchValue={searchData}
  />
*
* USE CASE 2: USING BUTTON INCLUDED WITHIN THIS COMPONENT
* REQUIRED PROPS : onClick, onChange, placeholder, buttonText
* - placeholder prop will be used as a search field placeholder
* - buttonText prop will be used as the text that will appear on your specific search header button
* - onChange props purpose should be to pass the search field input back to the parent component
* - onClick prop will define the internal button elements functionality
* - searchValue prop is passed as controlled input value from the parent component
* EXAMPLE:
* <RegistrySearchHeader
    onClick={onAddClick}
    placeholder={t("registers.functionalSystemChanges.placeholder.search")}
    buttonText={t('registers.addChange')}
    onChange={(e) => onSearch(e)}
    showInput={viewResourcePermissionExists}
    showButton={createResourcePermissionExists}
    searchValue={searchData}
 />
* */
